import type React from "react";
import { Link } from "react-router-dom";
import type { StartClipping } from "../landing/HeroSection";

interface FooterProps {
  onShowSignUp?: () => void;
  onShowTerms?: () => void;
  onShowPrivacy?: () => void;
  onStartClipping?: StartClipping;
}

const Footer: React.FC<FooterProps> = ({
  onShowTerms,
  onShowPrivacy,
  onStartClipping,
}) => {
  return (
    <footer className="border-t border-slate-200 bg-white">
      <div className="mx-auto grid max-w-7xl grid-cols-2 gap-x-8 gap-y-10 px-6 py-14 md:grid-cols-[1.3fr_1fr_1fr] md:gap-12 lg:px-8">
        <div className="col-span-2 md:col-span-1">
          <img
            src="/final-logo-icon.png"
            alt="TopClip"
            className="h-7 w-auto"
          />
          <p className="mt-5 text-lg font-semibold text-slate-800">
            Create viral clips in minutes
          </p>
          <a
            href="mailto:hello@topclip.ai"
            className="mt-4 inline-flex min-h-11 items-center text-slate-600 transition hover:text-blue-700"
          >
            hello@topclip.ai
          </a>
        </div>

        <div>
          <h2 className="text-base font-bold text-slate-900">Product</h2>
          <div className="mt-3 flex flex-col items-start">
            <button
              type="button"
              onClick={() => void onStartClipping?.()}
              className="min-h-11 text-slate-600 transition hover:text-blue-700"
            >
              Create Clips
            </button>
            <Link
              to="/dashboard"
              className="inline-flex min-h-11 items-center text-slate-600 transition hover:text-blue-700"
            >
              Account
            </Link>
          </div>
        </div>

        <div>
          <h2 className="text-base font-bold text-slate-900">Company</h2>
          <div className="mt-3 flex flex-col items-start">
            <button
              type="button"
              onClick={onShowTerms}
              className="min-h-11 text-slate-600 transition hover:text-blue-700"
            >
              Terms of service
            </button>
            <button
              type="button"
              onClick={onShowPrivacy}
              className="min-h-11 text-slate-600 transition hover:text-blue-700"
            >
              Privacy policy
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
